module.exports = __webpack_public_path__ + "static/media/salads.2c26bc63.svg";